// Fotos unter public/media. TODO Inhalt Kunde: KI-Standbilder (aussen, gastraum,
// tafel, og-meze) nach dem Shooting ersetzen.
const m = (file) => `/media/${file}`;

export const DISH_STRIP = [
    { src: m("oktopus.jpeg"), title: "Oktopus vom Grill", note: "Rucola, Zitrone", wide: true },
    { src: m("tzatziki.jpeg"), title: "Tzatziki", note: "Gurke, Kräuter" },
    { src: m("lammhaxe.jpeg"), title: "Lammhaxe", note: "Geschmort, Kartoffelpüree", wide: true },
    { src: m("saganaki.jpeg"), title: "Saganaki", note: "Feta, Peperoni" },
    { src: m("calamari.jpeg"), title: "Calamari", note: "Frittiert, Zitrone", wide: true },
    { src: m("rinderfilet.jpeg"), title: "Rinderfilet", note: "Vom Grill" },
];

// Galerie: Bilder kommen aus der API (Verwaltung → Galerie).
export const galleryImageUrl = (image) => `/api/public/gallery/${image._id}/image`;

export const GALLERY_FILTERS = ["Alle", "Haus", "Grill", "Meze", "Küche"];
